import { V2_APP_BFF_URL, V2_MYMEDPORTAL_BFF_URL } from '@/constants'

export default class V2Api {
  async redirectUserToV2 () {
    const jwtToken = localStorage.getItem('jwt')
    const form = document.createElement('form')
    form.method = 'POST'
    form.action = `${V2_APP_BFF_URL}/api/auth/signInFromV1`

    const input = document.createElement('input')
    input.type = 'hidden'
    input.name = 'jwt'
    input.value = jwtToken || ''

    form.appendChild(input)
    document.body.appendChild(form)
    form.submit()
  }

  async redirectResidentUserToV2 () {
    const jwtToken = localStorage.getItem('jwt')
    const form = document.createElement('form')
    form.method = 'POST'
    form.action = `${V2_MYMEDPORTAL_BFF_URL}/api/auth/signInFromV1`

    const input = document.createElement('input')
    input.type = 'hidden'
    input.name = 'jwt'
    input.value = jwtToken || ''

    form.appendChild(input)
    document.body.appendChild(form)
    form.submit()
  }

  async redirectTempResidentToV2 (code: string, lastName: string) {
    const form = document.createElement('form')
    form.method = 'POST'
    form.action = `${V2_MYMEDPORTAL_BFF_URL}/api/resident-portal/user/temp/v1`

    const codeInput = document.createElement('input')
    codeInput.type = 'hidden'
    codeInput.name = 'code'
    codeInput.value = code
    form.appendChild(codeInput)

    const lastNameInput = document.createElement('input')
    lastNameInput.type = 'hidden'
    lastNameInput.name = 'lastName'
    lastNameInput.value = lastName
    form.appendChild(lastNameInput)

    document.body.appendChild(form)
    form.submit()
  }
}
